export default {
  Subs: {
    For: "الاشتراك في",
    PTM: "منصة الأطباء «" + process.env.VUE_APP_INSTALL_NAME + "»",
    BySub: "عن طريق الاشتراك",
    Free: "مجاني",
    CostDesc: "بـ <period> لكل مستخدم",
    month: "شهر",
    day: "يوم",
    year: "سنة",
    Connect: "اتصال",
    Connectv2: "اشترك الآن",
    CorpPlan: {
      desc: "خطة فردية",
      feature_1: "برامج مخصصة",
      feature_2: "معالجة عدد محدد من الدراسات شهرياً باستخدام أي ذكاء اصطناعي",
      cost: "حسب الطلب",
      request: "أرسل طلب",
      requested: "تم إرسال طلبك بنجاح!",
      requested2:
        "سنتواصل معك قريباً لمناقشة التفاصيل وتقديم أفضل حل.إذا كانت لديك أسئلة، <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>اكتب لنا!</a>",
    },
    yourSub: "اشتراكك",
    PlansDesc: "الوصف التفصيلي للخطط",
    Offer: "العرض",
    EnterPromo: "أدخل الرمز الترويجي",
    Errors: {
      NotPurchase: "تعذر الاشتراك، يرجى المحاولة لاحقاً",
    },
    DiffSubs: "الاختلافات بين الخطط",
    Plan: "الخطة",
    Unavailable: "يجب إلغاء الاشتراك أولاً",
    extSub: "اختر الخطة الموسعة",
    lets: {
      modalTitle: {
        base: "أدخل",
        and: " و ",
        phone: " رقم هاتفك",
        email: "بريدك الإلكتروني",
      },
      text: "لإتمام الاشتراك، يرجى إدخال <PHONE><EMAIL>. سنستخدم هذه البيانات لإرسال إشعارات الاشتراك وتأكيد العمليات وغيرها من الرسائل المهمة.",
      formInvalid: "النموذج يحتوي على أخطاء",
    },
    cancelSub: "إلغاء الاشتراك",
    unsub: {
      title: "لن تتمكن من الوصول إلى:",
      modalTitle: "هل أنت متأكد من رغبتك في إلغاء الاشتراك؟",
      modalTitle2: "اختر سبب الإلغاء",
      cancel: "تم استئناف اشتراك <NAME>. سيتم الخصم التالي في <DATE>",
      yes: "إلغاء الاشتراك",
      no: "الاحتفاظ بالاشتراك",
      thx: {
        title: "شكراً لبقائك معنا!",
        continue: "الاستمرار في الاستخدام",
      },
      reasons: {
        0: "السعر غير مناسب",
        1: "لا أستخدم الخدمة",
        2: "الواجهة غير مريحة",
        3: "سبب آخر",
      },
      complete: {
        title: "تم إلغاء الاشتراك",
        text1: "سيبقى اشتراكك نشطًا حتى ",
        text2:
          "، ويمكنك الاستمرار في استخدامه حتى هذا التاريخ.سعداء برؤيتك مرة أخرى!",
        recover: "استعادة الاشتراك",
      },
    },
    backToSite: "العودة إلى الموقع",
    afterPay: {
      title: "تم تفعيل اشتراكك بنجاح!",
      text: "لديك الآن إمكانية الوصول إلى الوظائف المتقدمة!",
      buttonText: "ابدأ الآن",
    },
  },
};
